// src/theme/tokens/state.js
// Faz 1 · Component state (disabled, loading, readonly, focus-within) presetleri.
// Component variantlari icin import edilen JS objesi (Faz 2'de Button/Card/Input'a baglanir).

const state = {
  // ===== DISABLED =====
  disabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    filter: 'grayscale(40%)',
    pointerEvents: 'auto', // tooltip gosterilebilsin
    userSelect: 'none',
  },

  // ===== LOADING =====
  loading: {
    opacity: 0.7,
    cursor: 'wait',
    pointerEvents: 'none',
    userSelect: 'none',
  },

  // ===== READONLY =====
  // 'readonly' preseti, kaldirilan 'state.readonly.*' renk tokenlarini referans ediyordu;
  // hicbir component bu preseti tuketmedigi icin tamamen kaldirildi.

  // ===== HOVER (default interactive eleman) =====
  hover: {
    transform: 'translateY(-1px)',
    transition: 'transform var(--motion-duration-fast) var(--motion-ease-apple)',
  },

  // ===== ACTIVE (basili durum) =====
  active: {
    transform: 'translateY(0)',
    transition: 'transform var(--motion-duration-instant) var(--motion-ease-apple)',
  },
};

// Chakra semanticTokens.colors altinda expose edilecek state token'lari.
// 'state.empty.*', 'state.placeholder.*', 'state.readonly.*' tokenlari kaldirildi
// (sifir kullanim · component override'lari onlari hicbir zaman tuketmedi).
const stateTokens = {
  'state.disabled.bg':     { default: 'slate.100',  _dark: 'slate.800' },
  'state.disabled.text':   { default: 'slate.400',  _dark: 'slate.500' },
  'state.disabled.border': { default: 'slate.200',  _dark: 'slate.700' },

  'state.loading.overlay': { default: 'whiteAlpha.700', _dark: 'blackAlpha.700' },
};

export default state;
export { stateTokens };
